/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { Input, Typography } from 'antdV4';
import { Row, Col, Select, Button, Checkbox } from 'antd';
import { ErrorMessage } from '@hookform/error-message';
import ImageUpload from '../../../fit-studio/components/upload/ImageUpload';
import fitSurveyServices from '../../../../../services/fit-survey.services';
import { ELegacySurveyQuestionType } from '../dto/legacy-survey-form.dto';
import AnswerCard from './AnswerCard';

const LegacySurveyQuestionForm = () => {
  const {
    watch,
    reset,
    control,
    formState: { errors },
    setValue,
  } = useFormContext();

  const { data } = fitSurveyServices.useQueryGetLegacySurveyQuestionById(
    { questionId: watch('id') },
    (data) => {
      reset({
        ...data,
        formType: 'edit',
      });
    }
  );

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'answers',
  });

  useEffect(() => {
    if (watch('type') === 'select') {
      setValue('required', true);
    }
  }, [watch('type')]);

  return (
    <div>
      <Controller
        name="imageUrl"
        control={control}
        render={({ field: { value, onChange } }) => {
          return (
            <Row className="align-items-center mb-2">
              <Col span={24}>
                <ImageUpload
                  value={value}
                  onChange={onChange}
                  width={200}
                  height={200}
                  errors={errors}
                  notRequired
                />
              </Col>
            </Row>
          );
        }}
      />
      <Controller
        name="question"
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <Row className="align-items-center  mb-2">
              <Col span={4}>
                <Typography.Text>
                  คำถาม <span style={{ color: 'red' }}>*</span>
                </Typography.Text>
              </Col>
              <Col span={20}>
                <Input.TextArea
                  value={value}
                  onChange={onChange}
                  rows={2}
                  placeholder="คำถาม"
                />
              </Col>
              <ErrorMessage
                errors={errors}
                name="question"
                render={({ message }) => (
                  <Typography.Text className="mb-2 text-danger">
                    {message}
                  </Typography.Text>
                )}
              />
            </Row>
          );
        }}
      />
      <Controller
        name="type"
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <Row className="align-items-center  mb-2">
              <Col span={4}>
                <Typography.Text>
                  รูปแบบคำตอบ <span style={{ color: 'red' }}>*</span>
                </Typography.Text>
              </Col>
              <Col span={20}>
                <Select
                  value={value}
                  style={{ width: '100%' }}
                  onChange={(value) => {
                    if (value === 'text') {
                      setValue('answers', [
                        {
                          imageUrl: '',
                          answer: '',
                        },
                      ]);
                    } else {
                      if (data && data.answers) {
                        setValue('answers', data.answers);
                      } else {
                        setValue('answers', [
                          {
                            imageUrl: '',
                            answer: '',
                          },
                          {
                            imageUrl: '',
                            answer: '',
                          },
                          {
                            imageUrl: '',
                            answer: '',
                          },
                        ]);
                      }
                    }
                    onChange(value);
                  }}
                >
                  {ELegacySurveyQuestionType.map((item) => {
                    return (
                      <Select.Option key={item.value} value={item.value}>
                        {item.label}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Col>
              <ErrorMessage
                errors={errors}
                name="rewardId"
                render={({ message }) => (
                  <Typography.Text className="mb-2 text-danger">
                    {message}
                  </Typography.Text>
                )}
              />
            </Row>
          );
        }}
      />
      {watch('type') === 'select' &&
        fields
          .sort((a, b) => {
            return a.index - b.index;
          })
          .map((item, index) => {
            return (
              <AnswerCard
                key={item.id}
                item={item}
                index={index}
                control={control}
                errors={errors}
                remove={remove}
                setValue={setValue}
                fields={fields}
              />
            );
          })}
      {watch('type') === 'select' && (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            onClick={() => {
              append({
                answer: '',
                imageUrl: '',
              });
            }}
          >
            เพิ่มคำตอบ
          </Button>
        </div>
      )}
      {watch('type') === 'text' && (
        <Row className="align-items-center  mb-2">
          <Col span={4} />
          <Col span={20}>
            <div style={{ display: 'flex' }}>
              <div
                style={{ cursor: 'pointer', marginRight: 10 }}
                onClick={() => {
                  setValue('required', true);
                }}
              >
                <Checkbox
                  checked={watch('required')}
                  onChange={(value) => {
                    setValue('required', true);
                  }}
                  style={{ marginRight: 5 }}
                />
                <Typography.Text>บังคับตอบ</Typography.Text>
              </div>
              <div
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setValue('required', false);
                }}
              >
                <Checkbox
                  checked={!watch('required')}
                  onChange={(value) => {
                    setValue('required', false);
                  }}
                  style={{ marginRight: 5 }}
                />
                <Typography.Text>ไม่บังคับตอบ</Typography.Text>
              </div>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default LegacySurveyQuestionForm;
